import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Calendar, ArrowRight } from 'lucide-react';
import { blogs } from '../data/blogsData.jsx';

// Lazy load blog images if possible (handled in blogsData.jsx or via dynamic imports)
const Blog = () => {
  return (
    <div className="min-h-screen md:pt-20 pt-6">
      <Helmet>
        <title>Blog - Revolve Solutions | Technology Insights & Updates</title>
        <meta name="description" content="Explore insights, updates, and stories from the Revolve Solutions team on software development, technology, business intelligence, data engineering, and company culture." />
        <meta name="keywords" content="Revolve Solutions blog, software development insights, technology updates, business intelligence, data engineering, cloud migration, Yardi, Deltek Costpoint" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://revolvespl.com/blog" />
        <meta property="og:title" content="Blog - Revolve Solutions | Technology Insights & Updates" />
        <meta property="og:description" content="Latest insights and updates on software development, technology trends, and digital transformation from Revolve Solutions experts." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://revolvespl.com/blog" />
      </Helmet>

      {/* Hero Section */}
      <section className="py-20 bg-blue-gradient text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Our Blog</h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto">
              Insights, updates, and stories from the Revolve  team.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((post, index) => (
              <motion.article
                key={post.slug}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
              >
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-64 object-cover"
                  loading="lazy"
                />
                <div className="p-6">
                  <div className="flex items-center text-gray-500 text-sm mb-3">
                    <Calendar className="w-4 h-4 mr-1" />
                    <span>{post.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-navy mb-3">{post.title}</h3>
                  <p className="text-gray-600 mb-6">{post.subtitle}</p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700"
                  >
                    Read More <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;